var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgScorecards = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 11.6667H3.66667M22.3333 11.6667C23.8061 11.6667 25 12.8606 25 14.3333V22.3333C25 23.8061 23.8061 25 22.3333 25H3.66667C2.19391 25 1 23.8061 1 22.3333V14.3333C1 12.8606 2.19391 11.6667 3.66667 11.6667M22.3333 11.6667V9C22.3333 7.52724 21.1394 6.33333 19.6667 6.33333M3.66667 11.6667V9C3.66667 7.52724 4.86057 6.33333 6.33333 6.33333M6.33333 6.33333V3.66667C6.33333 2.19391 7.52724 1 9 1H17C18.4728 1 19.6667 2.19391 19.6667 3.66667V6.33333M6.33333 6.33333H19.6667",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScorecards, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scorecards.4a12b139.svg";
export { ForwardRef as ReactComponent };